import {setElementInnerHTML, setElementOnClick} from '../ui_utils/DomUtils'
import {PlayerEnums} from '../../../../shared/GameEnums'
import {RoomClientState} from '../RoomClientState.ts'
import {socket} from '../EntryShared'
import {UIRoomCenterSettingsSpeedView} from './UIRoomCenterSettingsSpeedView'

export class UIRoomCenterSettingsSpeedController {
    private readonly view: UIRoomCenterSettingsSpeedView
    private _currentSetting: keyof typeof PlayerEnums.GameSpeedSettings

    constructor(container: HTMLDivElement) {
        this.view = new UIRoomCenterSettingsSpeedView(container)
        this.currentSetting = this.view.speedDefaultSetting
    }

    get currentSetting(): keyof typeof PlayerEnums.GameSpeedSettings {
        return this._currentSetting
    }

    set currentSetting(value: keyof typeof PlayerEnums.GameSpeedSettings) {
        this._currentSetting = value
        setElementInnerHTML(this.view.speedInput, {key: `strings:colonistCommon.SpeedSettings.${this.currentSetting}`})
    }

    update(newRoomState: RoomClientState) {
        this.updateSpeedSettings(this.view.getSetting(newRoomState))

        this.view.container.classList.toggle('selected', this.currentSetting != this.view.speedDefaultSetting)
    }

    private updateSpeedSettings(newSetting: keyof typeof PlayerEnums.GameSpeedSettings) {
        const optionsArray = this.view.speedOptions
        const currentIndex = optionsArray.indexOf(this.currentSetting)
        const newIndex = optionsArray.indexOf(newSetting)
        if(currentIndex != newIndex) this.currentSetting = optionsArray[newIndex]
    }

    load(roomState: RoomClientState) {
        this.initSpeedSettings(roomState)
    }

    private initSpeedSettings(roomState: RoomClientState) {
        const {
            speedDivBody: footerDiv,
            speedRightArrow: rightArrow,
            speedLeftArrow: leftArrow,
            speedOptions: optionsArray,
            speedSocketCommand: socketCommand,
        } = this.view

        if(UIRoomCenterSettingsSpeedController.isGuest(roomState)) {
            footerDiv.className = 'option_body guest'
            rightArrow.classList.toggle('hidden', true)
            leftArrow.classList.toggle('hidden', true)
            setElementOnClick(rightArrow, () => undefined)
            setElementOnClick(leftArrow, () => undefined)
            return
        }
        footerDiv.className = 'option_body'
        leftArrow.classList.toggle('hidden', false)
        rightArrow.classList.toggle('hidden', false)
        setElementOnClick(leftArrow, () => {
            const currentIndex = optionsArray.indexOf(this.currentSetting)
            let newIndex = currentIndex - 1
            if(newIndex < 0) newIndex = optionsArray.length - 1
            this.currentSetting = optionsArray[newIndex]
            socketCommand(this.currentSetting)
        })

        setElementOnClick(rightArrow, () => {
            const currentIndex = optionsArray.indexOf(this.currentSetting)
            let newIndex = currentIndex + 1
            if(newIndex >= optionsArray.length) newIndex = 0
            this.currentSetting = optionsArray[newIndex]
            socketCommand(this.currentSetting)
        })
    }

    updateInteractabilityOfElements(roomState: RoomClientState) {
        this.load(roomState)
    }

    private static isGuest(roomState: RoomClientState): boolean {
        return socket.controller.session.id != roomState.hostSession.userSessionId
    }
}
